import Select, { Props, GroupBase } from 'react-select';

const WIZ_THEME = (theme: any) => ({
  ...theme,
  colors: {
    ...theme.colors,
    primary: 'rgb(103, 49, 231)',
    primary75: 'rgba(103, 49, 231, 0.75)',
    primary50: 'rgba(103, 49, 231, 0.5)',
    primary25: 'rgba(103, 49, 231, 0.12)',
  },
});

function WizSelect<Option = unknown, IsMulti extends boolean = false, Group extends GroupBase<Option> = GroupBase<Option>>(
  props: Props<Option, IsMulti, Group>
) {
  return <Select<Option, IsMulti, Group> theme={WIZ_THEME} {...props} />;
}

export default WizSelect;
export { WIZ_THEME };
